import $ from 'jquery'

const MODAL_SELECTOR = '#shared-amenities-modal'
const BODY_SELECTOR = '#shared-amenities-modal-body'
const SKELETON_SELECTOR = '#shared-amenities-modal-skeleton'

export default function () {
    return {
        init () {
            const modal = document.getElementById(MODAL_SELECTOR.slice(1))
            modal?.addEventListener('click', (e) => {
                if (e.target.closest('[data-retry-amenities]') && this._amenitiesResidenceId) {
                    this._amenitiesCache.delete(this._amenitiesResidenceId)
                    this.openAmenitiesModal(this._amenitiesResidenceId)
                }
            })
        },

        lazyloadFlooplan (id) {
            let $floorplanImage = $(`${id} .floor-plan`)
            let $floorplanLoader = $floorplanImage.next('.loader-wrapper')
            let $floorplanComingSoonImage = $floorplanLoader.next('.floor-plan-coming-soon')
            $floorplanImage
                .on('error', () => {
                    $floorplanImage.remove()
                    $floorplanLoader.addClass('tw:hidden')
                    $floorplanComingSoonImage.removeClass('tw:hidden')
                })
                .on('load', () => {
                    $floorplanLoader.addClass('tw:hidden')
                })
                .attr('src', $floorplanImage.data('src'))
        },

        _amenitiesCache: new Map(),
        _amenitiesAbort: null,
        _amenitiesResidenceId: null,
        _propertyCode: null,

        _getPropertyCode () {
            if (this._propertyCode === null) {
                const raw = this.$el?.dataset?.property
                this._propertyCode = raw ? (JSON.parse(raw).propertyCode || '') : ''
            }
            return this._propertyCode
        },

        _injectAmenitiesHtml (body, html) {
            body.innerHTML = html
            this.lazyloadFlooplan(MODAL_SELECTOR)
        },

        openAmenitiesModal (residenceId) {
            const modal = document.getElementById(MODAL_SELECTOR.slice(1))
            const body = document.getElementById(BODY_SELECTOR.slice(1))
            const skeleton = document.getElementById(SKELETON_SELECTOR.slice(1))

            if (!modal || !body || !skeleton) {
                return
            }

            this._amenitiesResidenceId = residenceId

            // Abort any in-flight fetch for a *different* residence.
            // Same-residence re-open while fetch is pending is a no-op
            // (the fetch will land and cache naturally).
            this._amenitiesAbort?.abort()
            this._amenitiesAbort = new AbortController()
            const signal = this._amenitiesAbort.signal

            // Bootstrap's modal plugin is attached to the global jQuery
            // loaded by the legacy common bundle, not the webpack-imported
            // one, so we call into window.jQuery explicitly.
            window.jQuery(modal).modal('show')

            const propertyCode = this._getPropertyCode()

            window.posthog?.capture('rental_amenities_modal_opened', {
                residence_id: residenceId,
                property_code: propertyCode,
            })

            // Cache hit — inject instantly, no fetch.
            const cached = this._amenitiesCache.get(residenceId)
            if (cached) {
                this._injectAmenitiesHtml(body, cached)
                window.posthog?.capture('rental_amenities_modal_loaded', {
                    residence_id: residenceId,
                    property_code: propertyCode,
                    fetch_ms: 0,
                    success: true,
                    cached: true,
                })
                return
            }

            // Cache miss — show skeleton and fetch.
            body.replaceChildren(skeleton.content.cloneNode(true))

            const url = window.Routing.generate(
                'vacatia_rental_residence_amenities_modal',
                { id: residenceId }
            )
            const startTime = performance.now()

            fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status}`)
                    }
                    return response.text()
                })
                .then((html) => {
                    // Always cache, even if the modal was closed or a
                    // different residence was opened in the meantime.
                    this._amenitiesCache.set(residenceId, html)

                    // Only write to the DOM if this residence is still
                    // the one the user asked for.
                    if (this._amenitiesResidenceId === residenceId) {
                        this._injectAmenitiesHtml(body, html)
                    }

                    window.posthog?.capture('rental_amenities_modal_loaded', {
                        residence_id: residenceId,
                        property_code: propertyCode,
                        fetch_ms: Math.round(performance.now() - startTime),
                        success: true,
                        cached: false,
                    })
                })
                .catch((error) => {
                    if (error.name === 'AbortError') {
                        window.posthog?.capture('rental_amenities_modal_loaded', {
                            residence_id: residenceId,
                            property_code: propertyCode,
                            fetch_ms: Math.round(performance.now() - startTime),
                            success: false,
                            reason: 'aborted',
                        })
                        return
                    }

                    body.innerHTML = `
                        <div class="tw:relative tw:p-6 tw:text-center tw:text-sm tw:space-y-4">
                            <a href="#" class="tw:absolute tw:top-2 tw:right-2 tw:text-ccc tw:hover:text-black" data-dismiss="modal" aria-label="Close">
                                &times;
                            </a>
                            <p>Unable to load floor plan &amp; amenities.</p>
                            <button type="button" data-retry-amenities
                                class="tw:border-solid tw:border tw:border-vacatia-blue tw:text-vacatia-blue tw:px-6 tw:py-2">
                                Try Again
                            </button>
                        </div>
                    `
                    window.posthog?.capture('rental_amenities_modal_loaded', {
                        residence_id: residenceId,
                        property_code: propertyCode,
                        fetch_ms: Math.round(performance.now() - startTime),
                        success: false,
                        error: String(error),
                    })
                })
        },
    }
}
